import { h } from 'preact'
import cls from 'classnames';

export const fades = {
    fadeIn: 'fade-in',
    fadeInLeft: 'fade-in-left',
    fadeInRight: 'fade-in-right',
}

// eslint-disable-next-line react/prop-types
export default function FadeIn({ children, fade, className }) {
    return <div className={cls(fade, className)}>{children}</div>
}
